import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { H3, LI, P, UL } from '../../../../AbstractElements';
import DashboardSvgIcon from '../../../../Utils/CommonComponents/DashboardSvgIcon';
import useCurrency from '../../../../Utils/FileUpload';
import { baseUrl } from '../../../../Utils/FileUpload';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';


export default function JobCardList() {
  const [cardData, setCardData] = useState<{ id: number; color: string; icon: string; count: number | string; text: string | React.ReactNode }[]>([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('token'); 
  const { currency } = useCurrency(); // Fetch currency

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [agentRes, customerRes, purchaseRes] = await Promise.all([
          axios.get(`${baseUrl}agent/getall`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(`${baseUrl}customer_detail/get_all_data_count`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(`${baseUrl}package/get_today_purchase_amount`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);
        const dynamicData = [
          {
            id: 1,
            color: 'primary',
            icon: 'employees',
            count: agentRes.data.length,
            text: 'Agents',
          },
          {
            id: 2,
            color: 'secondary',
            icon: 'hours-work',
            count: customerRes.data.total,
            text: 'Customers',
          },
          {
            id: 3,
            color: 'primary',
            icon: 'box',
            count: `${currency} ${purchaseRes.data.total_amount}`, // Add currency symbol
            text:"Today Sale",
          },
        ];
        setCardData(dynamicData);
      } catch (error) {
        console.error('Failed to fetch card data:', error);
      } finally {
        setLoading(false);
      }
    };

    if (currency) { // Only fetch data when currency is available
      fetchData();
    }
  }, [currency]); // Re-run when currency changes

  return (
    <UL className="d-flex align-center justify-content-center gap-3 simple-list flex-row">
      {loading
        ? Array(3).fill(0).map((_, index) => (
            <LI key={index} className='p-3'>
              <div className="d-flex gap-2">
                <div className="flex-shrink-0">
                  <Skeleton circle width={40} height={40} />
                </div>
                <div className="flex-grow-1">
                  <H3><Skeleton width={50} /></H3>
                  <P><Skeleton width={70} /></P>
                </div>
              </div>
            </LI>
          ))
        : cardData.map((item) => (
            <LI key={item.id}>
              <div className="d-flex gap-2">
                <div className={`flex-shrink-0 bg-light-${item.color}`}>
                  <DashboardSvgIcon className="stroke-icon" iconId={item.icon} />
                </div>
                <div className="flex-grow-1">
                  <H3>{item.count}</H3>
                  <P>{item.text}</P>
                </div>
              </div>
            </LI>
          ))}
    </UL>
  );
}





// import React from 'react'
// import { H3, LI, P, UL } from '../../../../AbstractElements'
// import { jobCardListData } from '../../../../Data/Dashboard/Default'
// import DashboardSvgIcon from '../../../../Utils/CommonComponents/DashboardSvgIcon'

// export default function JobCardList() {
//     return (
//         <UL className="d-flex align-center justify-content-center gap-3 simple-list flex-row">
//             {jobCardListData.map((item) => (
//                 <LI key={item.id}>
//                     <div className="d-flex gap-2">
//                         <div className={`flex-shrink-0 bg-light-${item.color}`}>
//                             <DashboardSvgIcon className='stroke-icon' iconId={item.icon} />
//                         </div>
//                         <div className="flex-grow-1">
//                             <H3>{item.count}</H3>
//                             <P>{item.text}</P>
//                         </div>
//                     </div>
//                 </LI>
//             ))}
//         </UL>
//     )
// }